// extracted by css-extract-rspack-plugin
var _1 = "HotkeysCheatSheet-m_container-CmdlZRx9";
var _2 = "HotkeysCheatSheet-m_hotkeys-AzYEjFX_";
var _3 = "HotkeysCheatSheet-m_key-_wsuaqbC";
var _4 = "HotkeysCheatSheet-m_keys-FsVWwbMl";
var _5 = "HotkeysCheatSheet-m_list-S8XywkMl";
var _6 = "HotkeysCheatSheet-m_text-KAHGLKcy";
var _7 = "HotkeysCheatSheet-m_title-eBatobcI";
export { _1 as "container", _2 as "hotkeys", _3 as "key", _4 as "keys", _5 as "list", _6 as "text", _7 as "title" }
